import { observer } from 'mobx-react-lite';
import { ReactNode } from 'react';

interface InfoItemProps {
    icon: ReactNode,
    title: string,
    text: string
}
export default observer(function InfoItem({
    icon,
    title,
    text
}: InfoItemProps) {
    return (
        <div className='flex gap-[5px] items-start'>
            <div className='flex justify-start items-center gap-[5px] w-[30%]'>
                {
                    typeof icon === 'string' ?
                        (
                            <img src={icon} alt={title} className='w-4 h-4' />
                        ) :
                        (
                            icon
                        )
                }
                <div className='flex-1 font-medium leading-lh-nor14 whitespace-nowrap'>{title}</div>
            </div>
            <div className='flex-1 font-medium leading-lh-nor14 break-all whitespace-pre-line'>
                {text || '--'}
            </div>
        </div>
    );
});
